import { useLocation } from "react-router";
import { useDirectionalNavigate } from "@acto/taskpane/field-sales-2/utils/viewTransitions";

export function useBackNavigation(fallback: string): () => void {
  const navigate = useDirectionalNavigate();
  const location = useLocation();

  return () => {
    const from = (location.state as { from?: string } | undefined)?.from;
    navigate(from ?? fallback, { direction: "pop" });
  };
}
